import React, { useCallback, useEffect, useState } from 'react';
import { actionTypesOfReasonForVisit } from 'reducer/actionType';
import { StateType } from 'reducer';
import { whichFootOptions } from 'lib/podiatryOptions';
import { usePersistRFVReducer } from 'reducer/reasonForVisit';
import styles from 'components/podiatry/page.module.scss';
import MetaTag from 'components/meta';
import Button from 'components/common/button';
import clsx from 'clsx';

type Props = {
  pageOptions: typeof whichFootOptions;
  nextPage: number;
  nextOrSubmitButton: (nextPage: number, submit?: boolean) => void;
};

function WhichFootScreen({
  pageOptions,
  nextPage,
  nextOrSubmitButton,
}: Props) {
  const [selectedOption, setSelectedOption] = useState<string[]>([]);
  const [error, setError] = useState<boolean>(false);

  const [state, dispatch] = usePersistRFVReducer();

  useEffect(() => {
    if (state) {
      const getWhichFoot = state.find(
        (object: StateType) => object.name === actionTypesOfReasonForVisit.WHICH_FOOT,
      );
      setSelectedOption(getWhichFoot.value);
    }
  }, []);

  const onSelectOptions = useCallback((item: string) => {
    setSelectedOption([item]);
    setError(false);
  }, []);

  const clickNextOrSubmit = async (nextPage: number) => {
    if (selectedOption.length === 0) {
      setError(true);
      return;
    }
    await dispatch({
      type: actionTypesOfReasonForVisit.WHICH_FOOT,
      name: pageOptions.title,
      value: selectedOption,
    });
    nextOrSubmitButton(nextPage);
  };

  return (
    <>
      <MetaTag title={pageOptions.title} />
      <h2 className={`marginTopZero ${styles.titleText}`}>
        {pageOptions.title}
      </h2>
      <p className={styles.titleTextSubText}>Choose one</p>
      {error && (
        <p className="error-message">
          Please select at least one option.
        </p>
      )}
      <div>
        {whichFootOptions.options.map((option) => {
          const selectedClass = selectedOption.find(
            (item) => item === option,
          );
          return (
            <p
              key={option}
              className={clsx('option', { 'selected-option': selectedClass })}
              onClick={() => onSelectOptions(option)}
              onKeyUp={() => {}}
            >
              {option}
            </p>
          );
        })}
      </div>
      <div className="next-button-fixed">
        <Button onClick={() => clickNextOrSubmit(nextPage)}>
          Next
        </Button>
      </div>
    </>
  );
}

export default WhichFootScreen;
